import { FC, memo } from "react";
// Resources
import styles from "./styles.module.scss";

interface Props {
  text: string;
}

const InfoTooltip: FC<Props> = ({ text }) => (
  <span className={styles.explain}>
    <span className={styles.explain__icon}>?</span>
    <span className={styles.explain__tooltip}>{text}</span>
  </span>
);

export default memo(InfoTooltip);
